import type { FC } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

export interface ProtectedRouteProps {
  isAuthenticated: boolean
  isAllowed: boolean
  restrictedPath: string
  authenticationPath: string
}

export const ProtectedRoute: FC<ProtectedRouteProps> = ({
  isAuthenticated,
  isAllowed,
  restrictedPath,
  authenticationPath
}) => {
  let redirectPath = ''
  const location = useLocation()

  if (!isAuthenticated) {
    redirectPath = authenticationPath
  }
  if (isAuthenticated && !isAllowed) {
    redirectPath = restrictedPath
  }

  if (redirectPath) {
    return <Navigate to={redirectPath} state={{ referrer: location }} />
  }
  return <Outlet />
}

export default ProtectedRoute
